import React, { useRef } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Skill from "./skill"
import { motion } from "framer-motion"

import { useOnScreen } from "../hooks"

const StyledSkillSection = styled.div`
  margin: 3rem 0;
  .title {
    font-size: 1.375rem;
    line-height: 1.625rem;
    font-weight: 700;
  }
  .tech-stacks {
    display: grid;
    /* Calculate how many columns are needed, depending on interests count */
    grid-template-columns: repeat(2, 6rem);
    grid-template-rows: repeat(2, auto);
    grid-auto-flow: row;
    column-gap: 1rem;
    row-gap: 1rem;
    /* Workaround: https://stackoverflow.com/questions/38993170/last-margin-padding-collapsing-in-flexbox-grid-layout */
    @media (min-width: 360px) {
      grid-auto-flow: row;
      grid-template-columns: repeat(3, 6rem);
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
      grid-auto-flow: row;
      grid-template-columns: repeat(4, 6rem);
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      grid-auto-flow: row;
      grid-template-columns: repeat(6, 6rem);
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      grid-auto-flow: row;
      grid-template-columns: repeat(8, 6rem);
      padding: 0;
    }
  }
`

const SkillSection = ({ title, skills }) => {
  const tRef = useRef()
  const tOnScreen = useOnScreen(tRef)
  const tVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }

  return (
    <motion.div
      ref={tRef}
      variants={tVariants}
      animate={tOnScreen ? "visible" : "hidden"}
    >
      <StyledSkillSection>
        <h4 className="title">{title}</h4>
        <div className="tech-stacks">
          {skills.map(
            (
              { skillName, fontAwesomeClassname, starred, isCustomSvg },
              key
            ) => (
              <Skill
                skillName={skillName}
                fontAwesomeClassname={fontAwesomeClassname}
                starred={starred}
                isCustomSvg={isCustomSvg}
                key={key}
              />
            )
          )}
        </div>
      </StyledSkillSection>
    </motion.div>
  )
}

SkillSection.propTypes = {
  skills: PropTypes.array,
  title: PropTypes.string,
}

export default SkillSection
